


































import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { FeedStateModule, UserStateModule } from '@/store/';
import { FeedModel } from '@/type';

@Component<FeedContentButtonsContainer>({})
export default class FeedContentButtonsContainer extends Vue {
  // PROPS
  @Prop({ type: Object, required: true })
  feed!: FeedModel.Read.Response.Feed;

  // MUTATIONS
  get isMyFeed() {
    return UserStateModule.selfUser.member_id === this.feed.member_id;
  }

  // METHODS
  async favorite() {
    const newFav = !this.feed.my_favorite_flg;

    await (this.feed.my_favorite_flg
      ? FeedStateModule.removeFavorite({
          requestBody: { module_type: 'topics', module_id: this.feed.topics_id },
        })
      : FeedStateModule.setFavorite({
          requestBody: { module_type: 'topics', module_id: this.feed.topics_id },
        }));
    this.$emit('commit-change');
  }
  async remove() {
    await FeedStateModule.removeFeed({ topicsId: this.feed.topics_id }).then(() => {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    });
  }
  handleClickEdit() {
    const topics_id = `${this.feed.topics_id}` as string;
    this.$router.push({ name: 'postWithArguments', params: { topics_id } });
  }

  // LIFECYCLE HOOKS
  mounted() {
    dom.watch();
  }
}
